export const searchTextState = {
    // searchText: '酒店神券',
    searchText: '',
    placeholder: ''
};
export var SearchTextAction;
(function (SearchTextAction) {
    SearchTextAction["UpdateSearchText"] = "UpdateSearchText";
    SearchTextAction["UpdatePlaceholder"] = "UpdatePlaceholder";
})(SearchTextAction || (SearchTextAction = {}));
export function SearchTextReducer(state = searchTextState, action) {
    switch (action.type) {
        case SearchTextAction.UpdateSearchText:
            {
                const newState = Object.assign(Object.assign({}, state), { searchText: action.data });
                return newState;
            }
        case SearchTextAction.UpdatePlaceholder:
            {
                const newState = Object.assign(Object.assign({}, state), { placeholder: action.data });
                return newState;
            }
        default:
            return state;
    }
}
